const LEGACY_SEO_CATEGORY_REDIRECTS = {
  // 1st round
  /*
  'diesel-mechanics': 'mechanics',
  'european-mechanics': 'mechanics',
  'nissan-mechanics': 'mechanics',
  '4x4-mechanics': 'mechanics',
  'toyota-mechanics': 'mechanics',
  'mazda-mechanics': 'mechanics',
  'mitsubishi-mechanics': 'mechanics',
  'logbook-servicing': 'mechanics',
  'ford-mechanics': 'mechanics',
  'vehicle-inspections': 'mechanics',
  'vehicle-diagnostics': 'mechanics',
  'car-servicing': 'mechanics',
  'hyundai-mechanics': 'mechanics',
   */
  // 2nd round
  /*
  '24-hour-vets': 'vets',
  'animal-dentistry': 'vets',
  'animal-microchipping': 'vets',
  'animal-shelters': 'vets',
  'mobile-vets': 'vets',
  'veterinary-instruments-supplies': 'vets',
  'veterinary-ultrasounds': 'vets',
  'pet-care': 'vets',
  'truck-tyres': 'tyres',
  'agricultural-tyres': 'tyres',
  'wheels-rims': 'tyres',
  'second-hand-tyres': 'tyres',
  'mobile-tyres': 'tyres',
  'tractor-tyres': 'tyres',
  'puncture-repairs': 'tyres',
  'bridgestone-tyres': 'tyres',
  'rim-repairs': 'tyres',
  'wills-estates-probates': 'lawyers',
  'public-notaries': 'lawyers',
  barristers: 'lawyers',
  'criminal-law': 'lawyers',
  'divorce-lawyers': 'lawyers',
  'migration-consultants': 'lawyers',
  'process-servers': 'lawyers',
  'immigration-lawyers': 'lawyers',
  'business-corporate-law': 'lawyers',
  'automatic-garage-doors': 'garage-doors',
  'custom-garage-doors': 'garage-doors',
  'garage-door-installations': 'garage-doors',
  'garden-sheds': 'sheds',
  gazebos: 'sheds',
  'industrial-sheds': 'sheds',
  'residential-sheds': 'sheds',
  'thai-massage': 'massage-therapists',
  'remedial-massage': 'massage-therapists',
  'mobile-massage': 'massage-therapists',
  'couples-massages': 'massage-therapists',
  'hot-stone-massage': 'massage-therapists',
  'oncology-massage': 'massage-therapists',
  'pregnancy-massage': 'massage-therapists',
  'shiatsu-massage': 'massage-therapists',
  'level-2-electricians': 'electricians',
  'electrical-switchboards': 'electricians',
  'electrical-wholesalers': 'electricians',
  'commercial-electricians': 'electricians',
  'electric-power-line-contractors': 'electricians',
  'emergency-electricians': 'electricians',
  'inspection-testing-services': 'electricians',
  'power-lighting-poles': 'electricians',
  'thermal-imaging': 'electricians',
  'industrial-electricians': 'electricians',
  'fibre-optic-cabling': 'electricians',
  'electrical-engineers': 'electricians',
  'heated-floor-installation': 'electricians',
  'uninterruptible-power-supply-ups': 'electricians',
  'electricity-providers': 'electricians',
  'emf-testing': 'electricians',
  'energy-management-consultants-services': 'electricians',
  'level-1-electricians': 'electricians',
  'outdoor-blinds': 'blinds',
  'motorised-blinds': 'blinds',
  'ziptrak-blinds': 'blinds',
  'blind-repairs': 'blinds',
  'roller-blinds': 'blinds',
  'veri-shades': 'blinds',
  'custom-curtains': 'curtains',
  'plantation-shutters': 'shutters',
  'canvas-awnings': 'awnings',
  'motorised-awnings': 'awnings',
  'retractable-awnings': 'awnings',
  'bath-basin-resurfacers': 'bathroom-renovations',
  'bathroom-benchtops': 'bathroom-renovations',
  'outdoor-showers': 'bathroom-renovations',
  'shower-sealing': 'bathroom-renovations',
  'tile-regrouting': 'bathroom-renovations',
  'building-construction-project-management': 'builders',
  'home-improvements': 'builders',
  'commercial-builders': 'builders',
  'dam-construction': 'builders',
  'granny-flats': 'builders',
  'laundry-renovations': 'builders',
  'tiny-home-builders': 'builders',
  'venetian-plasterers': 'builders',
  'building-repairs': 'builders',
  'butcher-supplies': 'butchers',
  'game-meat-suppliers': 'butchers',
  abattoirs: 'butchers',
  'halal-butchers': 'butchers',
  'upholstery-cleaning': 'carpet-cleaning',
  'leather-reconditioning-cleaning': 'carpet-cleaning',
  'rug-cleaning': 'carpet-cleaning',
  'mattress-cleaning-sanitisation': 'carpet-cleaning',
  'carpet-vinyl-repairs': 'carpet-cleaning',
  'paving-contractors': 'landscapers',
  'commercial-landscaping': 'landscapers',
  'landscape-architects': 'landscapers',
  'commercial-grounds-maintenance': 'landscapers',
  'garden-designers': 'landscapers',
  'structural-landscapers': 'landscapers',
  'vegetation-management': 'landscapers',
  'hedge-trimming': 'landscapers',
  'commercial-painting': 'painters',
  wallpapering: 'painters',
  'airless-spraying': 'painters',
  'high-rise-painting': 'painters',
  'house-spray-painting': 'painters',
  'rehabilitation-physiotherapy': 'physiotherapists',
  'sports-injury-physiotherapists': 'physiotherapists',
  'women-s-health-physiotherapy': 'physiotherapists',
  'top-soil': 'sand-soil-gravel-supplies',
  'decorative-stones-pebbles': 'sand-soil-gravel-supplies',
  'organic-soil': 'sand-soil-gravel-supplies',
  'sand-bags': 'sand-soil-gravel-supplies',
  'stakes-pegs': 'sand-soil-gravel-supplies',
  'stepping-stones': 'sand-soil-gravel-supplies',
  'sugar-cane-mulch': 'sand-soil-gravel-supplies',
  'boat-caravan-storage': 'self-storage',
  pallets: 'self-storage',
  'car-parks-parking-systems': 'self-storage',
  'vehicle-storage': 'self-storage',
  'cold-storage': 'self-storage',
   */
};

module.exports = LEGACY_SEO_CATEGORY_REDIRECTS;
